import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabVinculo = '/service/contabilidade/administracaoRH/'

class VinculoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getVinculo() {
        return this.conex.get(urlTabVinculo + 'retornaTodosVinculo/')
    }
}

export default VinculoService
